// import { useEffect } from 'react';
// import { Outlet } from 'react-router-dom';
// import { Layout } from 'antd';
// import Drawer from './Drawer';
// import Header from './Header';
// import Footer from './Footer';
// import Breadcrumbs from 'components/@extended/Breadcrumbs';
// import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// const { Content } = Layout;

// export default function DashboardLayout() {
//   const { menuMasterLoading } = useGetMenuMaster();

//   useEffect(() => {
//     const handler = () => handlerDrawerOpen(window.innerWidth >= 768);
//     window.addEventListener('resize', handler);
//     return () => window.removeEventListener('resize', handler);
//   }, []);

//   if (menuMasterLoading) return null;

//   return (
//     <Layout className="h-screen lg:overflow-hidden">
//       <Drawer />
//       <Layout className="flex flex-col h-screen">
//         <Header />
//         <Content className="mt-16 px-2 lg:px-5 py-5 overflow-y-auto overflow-x-hidden flex-1" style={{ background: '#f5f5f5' }}>
//           <Breadcrumbs />
//           {/* Page content */}
//           <main className="flex flex-1 flex-col">
//             <Outlet />
//           </main>

//           {/* Always at bottom when content is short */}
//           <div className="mt-auto">
//             <Footer />
//           </div>
//         </Content>
//       </Layout>
//     </Layout>
//   );
// }

import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';

import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

const { Content } = Layout;

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();

  useEffect(() => {
    const handler = () => {
      handlerDrawerOpen(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handler);

    return () => window.removeEventListener('resize', handler);
  }, []);

  if (menuMasterLoading) return null;

  return (
    <Layout className="h-screen">
      <Drawer />

      <Layout className="flex h-screen min-h-0 flex-col">
        <Header />

        <Content
          className="mt-16 flex min-h-0 flex-1 flex-col overflow-y-auto overflow-x-hidden px-2 py-5 lg:px-5"
          style={{ background: '#f5f5f5' }}
        >
          <Breadcrumbs />

          {/* Page content */}
          <main className="flex flex-1 flex-col">
            <Outlet />
          </main>

          {/* Always at bottom when content is short */}
          <div className="mt-auto">
            <Footer />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}
